import { start } from "./feature-toggles";

/**
 * Initializes the utility micro frontend.
 * This function should be called before using features of this micro frontend.
 */
const bootstrap = async (): Promise<void> => {
    await start();
};

export { bootstrap };
export { getAllowedMicroFrontends, resetAllowedMicroFrontendsCache } from "./allowed";
export { isFeatureActive, isFeatureActiveAsync } from "./feature-toggles";
